<template>
  <page-wrapper :title="title" :has-pad="true">
    <div class="wrapper">
      <insurance-editor
        v-model="form"
        :logo-url="logoUrl"
        :disabled="isEditorDisabled"
      ></insurance-editor>
      <div v-if="!isEditorDisabled" class="d-flex justify-content-between">
        <sc-button
          class="button-margin"
          variant="danger"
          @click="handleClickRemove"
          >ลบ</sc-button
        >
        <sc-button
          class="button-margin"
          variant="primary"
          @click="handleClickSave"
          >บันทึก</sc-button
        >
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper"
import ScButton from "@/lib/components/ScButton"
import { baanRueJaiClient } from "@/dependencies"
import { uploadPublicImage } from "@/god"
import InsuranceEditor from "../components/InsuranceEditor"

export default {
  components: {
    PageWrapper,
    ScButton,
    InsuranceEditor,
  },
  data() {
    const title = "รายละเอียดประกัน"
    const form = {
      label: "",
      description: "",
      url: "",
      logoFile: null,
    }

    const logoUrl = null

    return {
      title,
      form,
      logoUrl,
    }
  },
  computed: {
    isEditorDisabled() {
      return this.$isCallCenter
    },
  },
  watch: {
    form(form, oldForm) {
      if (this.form.logoFile === oldForm.logoFile) {
        return
      }

      this.logoUrl = URL.createObjectURL(this.form.logoFile)
    },
  },
  created() {
    this.setup()
  },
  methods: {
    setup() {
      this.setupData()
    },
    setupData() {
      this.setupForm()
    },
    async setupForm() {
      const insurance = await this.fetchInsurance()

      this.form = {
        label: insurance.title,
        description: insurance.subtitle,
        url: insurance.web_url,
        logoFile: null,
      }

      this.logoUrl = insurance.icon_url
    },
    async fetchInsurance() {
      const { id } = this.$route.params
      const response = await baanRueJaiClient.admin.insurances.get(id)

      return response.data.result
    },
    async handleClickSave() {
      try {
        await this.updateInsurance()
        this.$router.push({ name: "InsuranceListPage" })
      } catch (err) {
        this.$message.error("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง")
        // eslint-disable-next-line no-console
        console.error(err)
      }
    },
    async updateInsurance() {
      const { id } = this.$route.params
      const params = await this.getUpdateInsuranceParams()

      const response = await baanRueJaiClient.admin.insurances.put(id, params)

      return response.data.result
    },
    async getUpdateInsuranceParams() {
      const { label, description, url, logoFile } = this.form

      const params = {
        title: label,
        subtitle: description,
        web_url: url,
        icon_url: this.logoUrl,
      }

      if (logoFile) {
        params.icon_url = await uploadPublicImage(logoFile)
      }

      return params
    },
    async handleClickRemove() {
      // eslint-disable-next-line no-alert
      if (!window.confirm("ยืนยันการลบ")) {
        return
      }

      try {
        await this.removeInsurance()
        this.$router.push({ name: "InsuranceListPage" })
      } catch (err) {
        this.$message.error("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง")
        // eslint-disable-next-line no-console
        console.error(err)
      }
    },
    async removeInsurance() {
      const { id } = this.$route.params

      await baanRueJaiClient.admin.insurances.delete(id)
    },
  },
}
</script>

<style lang="scss" scoped>
.button-margin {
  margin-top: 30px;
}
</style>
